import React from "react";
import { useReportContext } from "./ReportContext";
import { IReportElement, IReportSlide } from "./ReprortContextTypes";
import { useSlideContext } from "./SlideContext";

/**
 * 
 * 
 <Text slideElemnt="total_budget">
    <Portion index={0} >Total Budget</Portion>
    <Portion index={2}>89%</Portion>
 </Text>

 */
const Portion = (
  props: React.PropsWithChildren<{
    /**
     * Refers to the static portion inside the template which this element replaces
     */
    portionIndex: number;
    /**
     * Paragraph which this element is going to replace
     */
    paragraphIndex: number;

    /**
     * TODO: add other attributes like fontName, color, etc. later
     */
  }>
) => {
  const slide = useSlideContext();

  // TODO: after rendering the element fetch the text data from inside of it
  const ref = React.useRef<HTMLDivElement>(null);
  const element = React.useRef<IReportElement>({
    isReady: false,
    type: "text",
    text: "",
    slideElement: "",
    portionIndex: props.portionIndex,
    paragraphIndex: props.paragraphIndex,
  });
  const report = useReportContext();
  React.useEffect(() => {
    slide?.addElement?.(element.current);
    if (ref.current) {
      element.current.text = ref.current.innerText;
      slide?.onElementReady?.(element.current);
    }
  }, [ref, report]);

  console.log("slide elementDefinition", element.current.elementDefinition);

  return <div ref={ref}>{props.children}</div>;
};

export default Portion;
